import { useTranslation } from 'react-i18next';
import { useRouteError } from 'react-router-dom';

export default function ErrorPage() {
  const { t } = useTranslation();
  const error = useRouteError() as { statusText: string; message: string };
  console.error(error);

  return (
    <div id="error-page">
      <h1>{t('errorPage.title')}</h1>
      <p>{t('errorPage.body')}</p>
      <p>
        <i>{error.statusText || error.message}</i>
      </p>
    </div>
  );
}
